import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-405dfff8")

_pushScopeId("data-v-405dfff8")
const _hoisted_1 = { class: "reportConfirm_reportItem" }
const _hoisted_2 = { class: "reportConfirm_reportItem_ecu" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_reportComfirmTitle, {
      titleTxt: "ECU数据",
      isShowRight: true,
      goPageType: "ecu"
    }),
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.ecuState), 1)
  ]))
})